import { Modal, ModalBody, ModalFooter, Button } from "react-bootstrap";
import Divider from "../Common/Divider/Divider";
import { uploadDocs } from "../../utils/Api";


function UploadDocsModal({ uploadDocsModalView, uploadDocsModalClose, docsData }) {

  const handleSubmit = async () => {

    const formData = new FormData();
    console.log(docsData.name);

    formData.append('file',docsData);

    const result=await uploadDocs(formData)

    uploadDocsModalClose()

  }

  return (
    <>
      <Modal show={uploadDocsModalView} onHide={uploadDocsModalClose}>
        <Modal.Header closeButton className="fs-4">
          Documents to Be Uploaded
        </Modal.Header>
        <ModalBody>
          <div className="row mx-3">
             <p>1.{docsData?.name}</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="btn btn-primary" onClick={()=>handleSubmit()}>
            Upload
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
export default UploadDocsModal;
